module.exports = "/images/webstore.png?a3e3e293aa9d80651d2b361b11fa2189";